import { z } from 'zod'

import { bargeTankSchema } from './bargeTankSchema'

const bdnSchema = z.object({
  density15: z.string().optional(),
  volume15: z.string().optional(),
})

export const bunkerSchema = z.object({
  barge: bargeTankSchema.optional(),
  bargeKind: z.string().optional(),
  bdn: bdnSchema.optional(),
  fuelGradePerBdn: z.string().optional(),
  volume15CPerVsl: z.string().optional(),
})
